export const initialState = 'ES'
export const LOCAL_STORAGE_LANGUAGE = 'language'